export default __webpack_public_path__ + "static/media/jumbotron_inicio_1.e411aa54.jpg";